import { SAMPLE_INSURANCE_BOX_FILE_IDS } from '@common/constants/client'
import { LOGO_DEV_PUBLIC_KEY } from '@common/constants/logoDev'

const environment = import.meta.env.VITE_APP_ENVIRONMENT || 'development'
const isProduction = environment === 'production'

const sampleInsuranceEmbedLinkIds =
  SAMPLE_INSURANCE_BOX_FILE_IDS[isProduction ? 'production' : 'other']

export default {
  apiPrefix: '/api/v1/',
  googleMapsApiKey: 'AIzaSyBvTmR2dsPfTtYhw4koT_Sq_4D_KhtPc0g',
  googleClientId: '924236216482-t1l1v8llinv548col5qo5vk9hld847sn.apps.googleusercontent.com',
  msalClientId: 'dbf272e1-d610-4d66-994a-453db128e2ac',
  defaultOpsEmail: 'ops@dwightfund.com',
  // Email domain that identifies internal users (gates Atlas access / invites)
  internalEmailDomain: 'dwightfund.com',
  logoDevPublicKey: LOGO_DEV_PUBLIC_KEY,
  isDev: import.meta.env.DEV,
  environment,
  // Dynamic envs are served from d-<PR number>.internal.dwightfunding.com.
  isDynamicEnv: /^d-[0-9a-f]+\.internal\./.test(window.location.hostname),
  vapidPublicKey: import.meta.env.VITE_APP_VAPID_PUBLIC_KEY || '',
  sampleInsuranceEmbedLinkIds,
} as const
